import React from 'react'
import ListWrapper from 'redesign/components/organisms/ListWrapper'
import { BIG_LIST_GAP } from 'redesign/components/organisms/ListWrapper/constants'
import EmptyPage from 'redesign/components/organisms/empty-pages'
import { EMPTY_PAGE_VARIANTS } from 'redesign/components/organisms/empty-pages/constants'
import EventsGroup from 'redesign/components/organisms/events-group'
import type { EventListProps } from './types'

const EventsList: React.FC<EventListProps> = ({ groupedEvents, hasMoreElements, loadMore, isLoading, onClickCard }) => (
  <ListWrapper
    loadMore={loadMore}
    showLoadMoreButton={hasMoreElements}
    isLoading={isLoading}
    hasContent={Boolean(groupedEvents?.length)}
    gap={BIG_LIST_GAP}
    noContentBlock={<EmptyPage variant={EMPTY_PAGE_VARIANTS.noEvents} />}
  >
    {groupedEvents.map((group) => (
      <EventsGroup key={group.dateLabel} {...group} onClickCard={onClickCard} />
    ))}
  </ListWrapper>
)

export default EventsList
